/**
 * Initialize the date time picker
 */
export function initializePaymentContainer() {
    if ($('select[name=state]').length > 0 && $('.payment-summary-container').length > 0) {
        $('select[name=state]').on('change', function () {
            $.ajax({
                type: 'GET',
                url: $('.payment-summary-container').data('action'),
                async: true,
                data: {country: $('select[name=country]').val(), state: $('select[name=state]').val()},
                success: function (data) {
                    $('.payment-summary-container').html(data.view);
                    if (data.amount !== undefined && data.amount > 0) {
                        $('input[name="amount"]').val(data.amount);
                    }
                    return true;
                }, error: function (data) {
                    return false;
                }
            });
        });
    }

    if ($('select[name=state]').length > 0 && $('.cart-summary-container').length > 0) {
        $('select[name=state]').on('change', function () {
            $.ajax({
                type: 'GET',
                url: $('.cart-summary-container').data('render'),
                async: true,
                data: {country: $('select[name=country]').val(), state: $('select[name=state]').val()},
                success: function (data) {
                    $('.cart-summary-container').html(data.view_summary)
                    if (data.amount !== undefined && data.amount > 0) {
                        $('input[name="amount"]').val(data.amount);
                    }
                    return true;
                }, error: function (data) {
                    return false;
                }
            });
        });
    }
}


